import { useState, type FormEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ApiError } from '../api/client';
import { useLogin } from '../api/queries';
import { GLOBAL_WORLD, readLastWorld, rememberLastWorld } from '../api/types';
import { WorldSelect } from '../components/WorldSelect';

export function LoginPage() {
  const login = useLogin();
  const navigate = useNavigate();
  const location = useLocation();
  const [worldKey, setWorldKey] = useState(readLastWorld);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const error = login.error instanceof ApiError ? login.error : null;
  const fieldError = (field: string): string | undefined =>
    error?.fields[field] ?? (error?.field === field ? error.message : undefined);
  const generalError = error && !error.field ? error.message : undefined;

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    // Der weltübergreifende Zugang schickt bewusst kein Weltkürzel mit.
    const payload =
      worldKey && worldKey !== GLOBAL_WORLD
        ? { worldKey, username, password }
        : { username, password };

    login.mutate(payload, {
      onSuccess: () => {
        rememberLastWorld(worldKey);
        const from = (location.state as { from?: string } | null)?.from;
        navigate(from && from !== '/login' ? from : '/', { replace: true });
      },
    });
  };

  return (
    <section className="card card-narrow">
      <h1>Anmelden</h1>
      <p className="muted">Zugang zum internen Stämme-Toolset.</p>

      {generalError && <div className="flash flash-error">{generalError}</div>}

      <form className="form" onSubmit={handleSubmit} noValidate>
        <WorldSelect
          purpose="login"
          value={worldKey}
          onChange={setWorldKey}
          error={fieldError('worldKey')}
          disabled={login.isPending}
        />

        <label className="field">
          <span>Benutzername</span>
          <input
            type="text"
            name="username"
            autoComplete="username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            required
          />
          {fieldError('username') && <small className="field-error">{fieldError('username')}</small>}
        </label>

        <label className="field">
          <span>Passwort</span>
          <input
            type="password"
            name="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
          {fieldError('password') && <small className="field-error">{fieldError('password')}</small>}
        </label>

        <button type="submit" className="btn btn-primary btn-block" disabled={login.isPending}>
          {login.isPending ? 'Wird geprüft …' : 'Anmelden'}
        </button>
      </form>

      <p className="muted center">
        Noch kein Zugang? <Link to="/register">Jetzt registrieren</Link>
      </p>
    </section>
  );
}
